import React from "react";
import { Link } from "react-router-dom";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString([], { dateStyle: "medium", timeStyle: "short" }) : null);

// One brief section: freshness first, then cited lines, then the source records (each links to its record).
export default function BriefSection({ s, stale }) {
  const shown = s.items.slice(0, 50);
  return (
    <section className="border border-erf-borderCream rounded bg-white p-4 space-y-3" data-testid={`brief-section-${s.key}`}
      aria-labelledby={`brief-h-${s.key}`}>
      <div className="flex flex-wrap items-baseline justify-between gap-2">
        <h2 id={`brief-h-${s.key}`} className="font-display font-semibold text-erf-dark">{s.title}</h2>
        <p className={`font-mono text-[11px] ${stale ? "text-amber-800" : "text-erf-dark/60"}`} data-testid={`brief-asof-${s.key}`}>
          {stale ? "Stale · " : ""}As of {fmt(s.as_of)}{s.latest_record_at ? ` · latest record ${fmt(s.latest_record_at)}` : ""}
        </p>
      </div>
      {s.lines.length === 0 ? (
        <p className="text-sm text-erf-dark/80" data-testid={`brief-empty-${s.key}`}>{s.empty_line}</p>
      ) : (
        <ul className="space-y-1 text-sm" data-testid={`brief-lines-${s.key}`}>
          {s.lines.map((ln, i) => (
            <li key={i}>{ln.text} <span className="font-mono text-[11px] text-erf-dark/60">[{ln.record_ids.length} source{ln.record_ids.length === 1 ? "" : "s"}]</span></li>
          ))}
        </ul>
      )}
      {shown.length > 0 && (
        <details className="text-sm">
          <summary className="cursor-pointer min-h-[44px] flex items-center font-nav font-semibold" data-testid={`brief-sources-toggle-${s.key}`}>
            Source records ({s.count})
          </summary>
          <ul className="mt-1 space-y-1" data-testid={`brief-sources-${s.key}`}>
            {shown.map((it) => (
              <li key={`${it.record_id}-${it.change || ""}`}>
                {it.link ? (
                  <Link to={it.link} className="underline inline-flex min-h-[44px] items-center" data-testid={`brief-cite-${s.key}-${it.record_id}`}>{it.label}</Link>
                ) : (
                  <span data-testid={`brief-cite-${s.key}-${it.record_id}`}>{it.label} <em className="text-erf-dark/60">({it.available_when || "no page"})</em></span>
                )}
              </li>
            ))}
          </ul>
          {s.count > shown.length && <p className="text-xs text-erf-dark/60">Showing {shown.length} of {s.count}.</p>}
        </details>
      )}
    </section>
  );
}
